module.exports = __webpack_public_path__ + "static/img/zhouhongyi.6036ee0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/mentorTeam/images/zhouhongyi.png
// module id = Nlx7
// module chunks = 0